
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdershippingBooksGrid extends Serenity.EntityGrid<OrdershippingBooksRow, any> {
        protected getColumnsKey() { return OrdershippingBooksColumns.columnsKey; }
        protected getDialogType() { return OrdershippingBooksDialog; }
        protected getIdProperty() { return OrdershippingBooksRow.idProperty; }
        protected getInsertPermission() { return OrdershippingBooksRow.insertPermission; }
        protected getLocalTextPrefix() { return OrdershippingBooksRow.localTextPrefix; }
        protected getService() { return OrdershippingBooksService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {
                        Orders.OrdershippingBooksService.Delete({
                            EntityId: item.OrdershippingBooksId,
                        }, response => {
                            this.refresh();
                        });
                    });
                }
            }
        }
    }
}